module.exports = __webpack_public_path__ + "img/empty_state_cart_light.9ab1ca4b.svg";